import { useState } from "react";

import { ConfirmActionModal, TrashIcon } from "~/common/components";
import { useDeleteInvitationLink } from "~/providers/hooks/queries/useInvitationLinks";

interface DeleteConsultationLinkModalProps {
  isDeleteEnabled?: boolean;
  linkId: string;
}

export const DeleteConsultationLinkModal = ({
  isDeleteEnabled,
  linkId,
}: DeleteConsultationLinkModalProps) => {
  const [show, setShow] = useState(false);

  const {
    mutate: deleteConsultationLinkMutation,
    isPending: isDeleteConsultationLinkPending,
  } = useDeleteInvitationLink(() => setShow(false));

  return (
    <div>
      <button
        className="relative -top-[1px] flex items-center justify-center disabled:cursor-not-allowed disabled:text-neutral-400"
        disabled={!isDeleteEnabled}
        onClick={() => {
          setShow(true);
        }}
      >
        <TrashIcon />
      </button>
      <ConfirmActionModal
        show={show}
        isLoading={isDeleteConsultationLinkPending}
        onConfirm={() => deleteConsultationLinkMutation(linkId)}
        onClose={() => setShow(false)}
        title="Delete link"
        description="Deleting a consultation request link is permanent. Patients will no longer be able to initiate a consultation using the QR code or URL for this link."
        confirmButtonText="Delete link"
        titleClassName="text-2xl"
      >
        <p className="leading-5 text-gray-70">
          Are you sure you want to delete this link?
        </p>
      </ConfirmActionModal>
    </div>
  );
};
